export function storesName(values, stores) {
  if (values !== undefined && stores !== undefined && stores !== '') {
    return stores
      .split(',')
      ?.map(
        (magasin) =>
          values?.find((store) => String(store.mag_num) === magasin)?.mag_nom
      )?.join(",");
  }
}

export function gestionKeyDescr(values, types, key, descr) {
  let found = values?.find((item) => item[key] === types);
  if (found !== undefined) return found[descr];
}
